import { useBadgeData } from './useBadgeCounts';

export const ASSIGNED_JOBS_QUERY_KEY = ['assigned-jobs'];
export const ASSIGNED_JOBS_COUNT_QUERY_KEY = ['assigned-jobs', 'count'];

/** Open (not yet completed) jobs assigned to the signed-in user, for the sidebar badge. */
export function useAssignedJobsCount() {
  return useBadgeData().data?.assigned_jobs ?? 0;
}
